module.exports = __webpack_public_path__ + "img/mile4-m@1.2e211b2c.jpg";